import React, {useState, useEffect} from "react";
import {NavBar, List} from "antd-mobile";
import {CheckCircleFill} from "antd-mobile-icons";
import {useNavigate} from "react-router-dom";
import {t} from "../../../../i18n";
import {useTranslation} from "react-i18next";
import { getNavBarContainerStyle } from "../../../../utils/deviceUtils";
import { reloadNativeWebLocal } from "../../../../utils/appRuntime";

interface PickUpLanguagePageProps {
}

const PickUpLanguagePage: React.FC<PickUpLanguagePageProps> = () => {
    const navigate = useNavigate();
    const {i18n} = useTranslation();
    const [currentLang, setCurrentLang] = useState('zh-CN');

    useEffect(() => {
        setCurrentLang(i18n.language);
    }, []);

    const handleLanguageChange = (lang: string) => {
        setCurrentLang(lang);
        i18n.changeLanguage(lang)
            .then(() => {
                reloadNativeWebLocal();
                setTimeout(() => {
                    window.location.reload();
                }, 100);
            })
            .catch((err: Error) => {
                console.error('Error changing language:', err);
            });
    };

    return (
        <div className="flex flex-col h-screen bg-white">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                    onBack={() => navigate(-1)}
                >
                    {t('pages.pickUp.useMenu.language')}
                </NavBar>
            </div>

            <List className="mt-2">
                <List.Item
                    extra={currentLang === 'zh-CN' ? <CheckCircleFill color="#00b578"/> : null}
                    onClick={() => handleLanguageChange('zh-CN')}
                    arrowIcon={false}
                >
                    简体中文
                </List.Item>
                <List.Item
                    extra={currentLang === 'en-US' ? <CheckCircleFill color="#00b578"/> : null}
                    onClick={() => handleLanguageChange('en-US')}
                    arrowIcon={false}
                >
                    English
                </List.Item>
                 <List.Item
                    extra={currentLang === 'es-ES' ? <CheckCircleFill color="#00b578"/> : null}
                    onClick={() => handleLanguageChange('es-ES')}
                    arrowIcon={false}
                 >
                    Español
                </List.Item>
            </List>
        </div>
    );
};

export default PickUpLanguagePage;